export const random = (arr, excludeIndex = -1) => {
  if (arr.length <= 1) return { item: arr[0], index: 0 };
  let index;
  do {
    index = Math.floor(Math.random() * arr.length);
  } while (index === excludeIndex);
  return { item: arr[index], index };
};

export const playAudioBeep = (freq = 800, duration = 0.12, type = "sine") => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    gain.gain.setValueAtTime(0.2, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch (e) {
    // Audio might be blocked if user has not interacted or unsupported
  }
};
